import type { Slider } from "@ui/slider";
import { useState, type ComponentProps } from "react";

export function useRange(value: ComponentProps<typeof Slider>["value"] = []) {
  const [internalValues, setInternalValues] = useState(value);

  function onChangeValue(values: number[]) {
    setInternalValues(values);
  }

  return {
    internalValues,
    onChangeValue,
  };
}
